/*
  Fetch all the data required to power the shop home page.
*/
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { syncShopFeatures } from '../../../../Actions/FeaturedActions';

const HomeShopData = props => {
  React.useEffect(() => {
    props.syncShopFeatures({ fromHomePage: true });
  }, []);
  return null;
};

HomeShopData.propTypes = {
  featured: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { featured } = state;
  return { featured };
};

export default connect(mapStateToProps, {
  syncShopFeatures
})(HomeShopData);
